import styled from 'styled-components'
import Pointer from 'assets/images/Pointer.svg'
import { formBreakpoint } from 'globalStyles'

export const Container = styled.div`
  position: fixed;
  top: 30%;
  left: 1.6rem;
  z-index: var(--routes-z-index);
  min-width: 33rem;

  @media screen and (max-width: ${formBreakpoint}) {
    top: auto;
    left: 0;
    bottom: 0;
    width: 100%;
    min-width: auto;
  }
`

export const Wrapper = styled.div`
  --active: var(--grey-100);
  --radius: 0.8rem;
  --max-show-items: 6;

  background: var(--light);
  border: 1px solid var(--grey-400);
  box-shadow: 0 1px 1px (--shadow);
  border-radius: var(--radius);

  & > *:first-child {
    border-top-left-radius: var(--radius);
    border-top-right-radius: var(--radius);
  }

  & > *:last-child {
    border-bottom-left-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
  }

  @media screen and (max-width: ${formBreakpoint}) {
    --max-show-items: 3;
  }

  @media screen and (max-width: ${formBreakpoint}) {
    border: 0;
    border-radius: 0;
    border-top-left-radius: var(--radius);
    border-top-right-radius: var(--radius);
    box-shadow: none;
  }
`

export const OpeningRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.4rem 1.6rem;

  background: var(--active);
  color: var(--grey-900);
  font-size: 1.2rem;
  line-height: 2rem;
  font-weight: 400;

  &:last-child {
    padding: .4rem .6rem;
  }

  @media screen and (max-width: ${formBreakpoint}) {
    font-size: 1.4rem;
    font-weight: 500;
  }
`

export const List = styled.ul`
  --item-height: 5rem;
  --border: 1px solid var(--grey-400);
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: var(--border);
  border-top: var(--border);
  overflow: hidden;
  max-height: calc(var(--item-height) * var(--max-show-items));
  will-change: max-height;
`

type RoutesRowProps = {
  selected: boolean
  hovered: boolean
}

export const Row = styled.li<RoutesRowProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 1.6rem;
  min-height: 5rem;
  white-space: nowrap;

  background: ${(props) => (props.selected || props.hovered ? 'var(--active)' : 'transparent')};
  cursor: url(${Pointer}), pointer;

  &:not(:last-child) {
    border-bottom: 1px solid var(--grey-300);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0.4rem;
    height: 100%;
    background-color: ${(props) => (props.selected ? 'var(--brand-700)' : 'transparent')};
  }

  &:hover {
    background: var(--active);
  }
`

export const TimeCount = styled.div`
  color: var(--brand-800);
  margin-left: auto;

  @media screen and (max-width: ${formBreakpoint}) {
    margin-right: 1.6rem;
  }
`

export const StopNames = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-medium);
`

export const IconContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  background: var(--brand-200);
  border: 1px solid var(--brand-400);
  border-radius: 2rem;
  color: var(--brand-700);
  height: 2.4rem;
  padding: 0 0.8rem;

  & > *:not(:last-child) {
    margin-right: .5rem;
  }
`

export const MobileIcon = styled.span`
  display: none;
  @media screen and (max-width: ${formBreakpoint}) {
    display: block;
  }
`

export const RouteTicketContainer = styled.div`
  position: relative;
  margin-left: .8rem;
`

export const OrderIcon = styled.span`
  margin-left: 0.6rem;
  margin-bottom: 0.2rem;
`

export const PaginationIcon = styled.span`
  display: inline-block;
  padding: 1rem 1rem;
  cursor: url(${Pointer}), auto;
`

type TicketTooltipProps = {
  show: boolean
}

export const TicketTooltip = styled.span<TicketTooltipProps>`
  display: inline-block;
  min-width: 18rem;
  padding: 0.2rem 1rem;
  position: absolute;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 2rem;
  color: var(--light);
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  border-radius: 6px;
  background: var(--dark);
  opacity: ${(props) => (props.show ? 1 : 0)};
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  will-change: opacity;
  z-index: 2000;

  &::before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    top: -4px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    border-top-left-radius: 2px;
    background-color: var(--dark);
  }
`
